"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "moscazzano": {
    "2255ed3a": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-ca-del-lupo": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51a4e545": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-caselle": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8a262c94": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-dama": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2c3c1bdd": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-letimbro": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c186d03b": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "skipSearch": false
    }],
    "localita-mulino": [{
      "hkey": "8519c64a",
      "slug": "moscazzano",
      "name": "Moscazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;